import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';
import { buildHttpParams } from '../utils';
import { PaginatedResponse } from '../common/models/common.model';
import { Farmer, FarmerRegions, FarmerVisit } from './farmers.model';

@Injectable({
  providedIn: 'root',
})
export class FarmersService {
  private readonly baseUrl = 'farmers';

  constructor(private apiService: ApiService) {}

  public get_farmers(q = {}): Observable<PaginatedResponse<Farmer>> {
    const params = buildHttpParams(q);
    return this.apiService.get(`${this.baseUrl}/farmers/`, params);
  }

  public get_farmer_by_id(id: string): Observable<Farmer> {
    return this.apiService.get(`${this.baseUrl}/farmers/${id}/`);
  }

  public get_farmer_visits(q = {}): Observable<PaginatedResponse<FarmerVisit>> {
    const params = buildHttpParams(q);
    return this.apiService.get(`${this.baseUrl}/visits/`, params);
  }

  public get_regions(): Observable<FarmerRegions> {
    return this.apiService.get(`${this.baseUrl}/farmers/regions/`);
  }

  public crops_lighter_list(): Observable<{ key: string; value: string }[]> {
    return this.apiService.get(`${this.baseUrl}/farmers/crops_lighter_list/`);
  }

  public farmers_lighter_list(): Observable<
    {
      full_name: string;
      id: string;
      whatsapp_number: string;
      mobile_number: string;
    }[]
  > {
    return this.apiService.get(`${this.baseUrl}/farmers/lighter_list/`);
  }

  public send_message(reqBody: { farmer_ids: string[]; message: string }): Observable<any> {
    return this.apiService.post(`${this.baseUrl}/whatsapp/`, reqBody);
  }

  public export(employeeId?: string): Observable<Blob> {
    const query: Record<string, string> = {};
    if (employeeId) query['employee_id'] = employeeId;
    const params = buildHttpParams(query);
    return this.apiService.getBlob(`${this.baseUrl}/farmers/export/`, params);
  }
}
